import React from 'react';
import {useSelector} from 'react-redux';
import {selectIsTutorialActive} from '../../../redux/reducers/privateStateReducer/selectors';
import './TutorialModalExplanation.css';

/**
 * Обучающий блок-пояснение ВНУТРИ штатных игровых модалок (итоги боя, захват
 * города, итоги раунда): в обучении эти модалки остаются, а блок разъясняет
 * смысл их содержимого. Вне обучения не рендерится вовсе.
 */
const TutorialModalExplanation = ({children}) => {
  const isTutorialActive = useSelector(selectIsTutorialActive);

  if (!isTutorialActive) {
    return null;
  }

  return (
    <div className={'tutorial-modal-explanation'}>
      <img
        className={'tutorial-modal-explanation_icon'}
        src={'/img/icons/question.png'}
        alt={''}
        aria-hidden={'true'}
      />
      <div className={'tutorial-modal-explanation_text'}>{children}</div>
    </div>
  );
};

export default TutorialModalExplanation;
